<template>
  <b-container style="position:fixed; width:100vw;height:50px;background-color:#ffffff;bottom:0px;left:0px;border-top:1px solid #F7F7F8;">
    <b-row>
      <b-col @click="goToTab('prizes')" :class="{selectedPrizeFixedMenu: isSelected('prizes')}" style="line-height:16px;text-align:center;margin-top:8px;">
        <font-awesome-icon v-if="isSelected('prizes')" style="font-size:16px;" :style="{color: getCssColor('primary_bt')}" :icon="['far', 'gift']"/>
        <font-awesome-icon v-else style="font-size:16px;color:#525962;" :icon="['fal', 'gift']"/>
        <br/>
        <span style="font-size:10px;" :style="{color: isSelected('prizes') ? getCssColor('primary_bt') : '#525962'}">Prêmios</span>
      </b-col>
      <b-col @click="goToTab('points')" :class="{selectedPrizeFixedMenu: isSelected('points')}" style="line-height:16px;text-align:center;margin-top:8px;">
        <font-awesome-icon v-if="isSelected('points')" style="font-size:16px;" :style="{color: getCssColor('primary_bt')}" :icon="['far', 'wallet']"/>
        <font-awesome-icon v-else style="font-size:16px;color:#525962;" :icon="['fal', 'wallet']"/>
        <br/>
        <span style="font-size:10px;" :style="{color: isSelected('points') ? getCssColor('primary_bt') : '#525962'}">Pontos</span>
      </b-col>
      <b-col v-if="$store.state.membershipConfigs && $store.state.membershipConfigs.scan === true" @click="goToTab('scan')" :class="{selectedPrizeFixedMenu: isSelected('scan')}" style="line-height:16px;text-align:center;margin-top:8px;">
        <font-awesome-icon v-if="isSelected('scan')" style="font-size:16px;" :style="{color: getCssColor('primary_bt')}" :icon="['far', 'barcode-read']"/>
        <font-awesome-icon v-else style="font-size:16px;color:#525962;" :icon="['fal', 'barcode-read']"/>
        <br/>
        <span style="font-size:10px;" :style="{color: isSelected('scan') ? getCssColor('primary_bt') : '#525962'}">Nota Fiscal</span>
      </b-col>
      <b-col @click="goToTab('claim')" :class="{selectedPrizeFixedMenu: isSelected('claim')}" style="line-height:16px;text-align:center;margin-top:8px;position:relative;">
        <div style="position:relative;max-width:50px;margin:0px auto;">
          <PrizesBullet />
          <font-awesome-icon v-if="isSelected('claim')" style="font-size:16px;" :style="{color: getCssColor('primary_bt')}" :icon="['far', 'gifts']"/>
          <font-awesome-icon v-else style="font-size:16px;color:#525962;" :icon="['fal', 'gifts']"/>
          <br/>
          <span style="font-size:10px;" :style="{color: isSelected('claim') ? getCssColor('primary_bt') : '#525962'}">Resgatar</span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import PrizesBullet from '@/components/PrizesBullet'
import colors from '@/mixins/colors'
export default {
  props: {
    selected:String
  },

  mixins: [colors],

  components: {PrizesBullet},

  methods: {
    isSelected (menu) {
      if (menu === this.selected){
        return true
      } else {
        return false
      }
    },

    goToTab (name) {
      if (name !== this.selected) {
        if (name === 'prizes') {
          this.$router.push({path: '/membership_prizes'})
        } else if (name === 'points') {
          this.$router.push({path: '/membership_points'})
        } else if (name === 'claim') {
          this.$router.push({path: '/membership_orders'})
        } else if (name === 'scan') {
          this.$router.push({path: '/membership_scan'})
        }
      }
    }
  }
}
</script>

<style lang="scss">
.selectedPrizeFixedMenu {
  font-weight:bold;
}
</style>
